// extracted by mini-css-extract-plugin
module.exports = {"varSpUp6":"2.5rem","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","var-md-max":"1023.98px","varMdMax":"1023.98px","container":"container--5ffd0"};